import * as React from "react";
import * as ReactDOM from "react-dom";
import { IOWidget, Pair, mk_pair, Sum, inl, inr, Widget, Unit, Options, mk_widget, option } from "../widget";

export interface AnyProps<i,o> {
  input:i
  widgets:IOWidget<i,o>[]
  on_done:(output:o) => void
  options?:Options
}
export interface AnyState<i,o> {}
export class Any<i,o> extends React.Component<AnyProps<i,o>, AnyState<i,o>> {
  constructor(props:AnyProps<i,o>, context:any) {
    super(props, context)

    this.state = {}
  }

  render() {
    return <React.Fragment>
      {this.props.widgets.map(widget =>
        widget(this.props.input).run(output =>
          this.props.on_done(output)),
      )}
    </React.Fragment>
  }
}

export const any_io = function<i,o>(options?:Options) : (widgets:IOWidget<i,o>[]) =>
  IOWidget<i,o> {
  return widgets => (input:i) => mk_widget({
    run:(on_done:(outputs:o) => void) =>
      React.createElement<AnyProps<i,o>>(Any, { options:options, on_done, widgets, input, key: option("key", options) })
  })
}

export const any = function<o>(options?:Options) : (widgets:Widget<o>[]) => Widget<o> {
  return widgets => any_io<Unit,o>(options)(widgets.map(w => (_:Unit) => w))({})
}
